<section class="page-shell">
  <header class="page-header">
    <h4>Recherche Consultant</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading() || !hasActiveFilters()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Recherche impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel search-panel dbw-card dbw-card--xl">
      <h5>Filtres</h5>

      <div class="filters">
        <div class="filters-group">
          <div class="subtitle-1">Consultant</div>
          <div class="filters-row">
            <oui-textfield
              label="ConsultantId"
              type="number"
              [value]="consultantIdFilter()"
              (valueChange)="onConsultantIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code consultant"
              [value]="consultantCodeFilter()"
              (valueChange)="onConsultantCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom consultant"
              [value]="consultantNameFilter()"
              (valueChange)="onConsultantNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="ArianeId"
              type="number"
              [value]="arianeIdFilter()"
              (valueChange)="onArianeIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-select-filter
              class="search-field-status"
              label="Statut consultant"
              type="list"
              listPlaceholder="Rechercher un statut"
              [listOptions]="consultantStatusOptions"
              [value]="consultantStatusFilter()"
              (valueChange)="onConsultantStatusFilterChange($event ?? [])">
            </oui-select-filter>
          </div>
        </div>
      </div>
    </article>

    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h5>Résultats</h5>
          <p>
            @if (hasActiveFilters()) {
              @if (searchPending() || loading()) {
                Recherche en cours.
              } @else if (page()) {
                {{ page()?.totalCount ?? 0 }} consultant(s) trouvé(s).
              } @else {
                Aucun résultat chargé.
              }
            } @else {
              Renseigner au moins un filtre pour lancer la recherche.
            }
          </p>
        </div>
      </div>

      @if (!hasActiveFilters()) {
        <dbw-state-card
          appearance="info"
          [compact]="true">
          <p>La recherche ne charge rien tant qu'aucun filtre n'est saisi.</p>
        </dbw-state-card>
      }

      @if (searchPending() || loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Recherche Atlas en cours.</p>
        </dbw-state-card>
      }

      @if (!searchPending() && !loading() && hasActiveFilters() && page() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun consultant ne correspond à la recherche courante.</div>
      }

      @if (!searchPending() && !loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="consultant">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultant
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-card
                    [id]="row.consultantId"
                    [code]="row.consultantCode || '-'"
                    [name]="row.displayName || 'Consultant #' + row.consultantId"
                    [statusCode]="row.statusCode"></dbw-consultant-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Statut
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-status-tag [statusCode]="row.statusCode"></dbw-consultant-status-tag>
                </td>
              </ng-container>

              <ng-container matColumnDef="affiliationDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Affiliation
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.affiliationDate ? (row.affiliationDate | date: 'dd/MM/yyyy') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="resiliationDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Résiliation
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.resiliationDate ? (row.resiliationDate | date: 'dd/MM/yyyy') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="qualification">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Qualification
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ getQualificationLabel(row) }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
